/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_CountriesInputs */

const en_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Countries`)
};

const es_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los países`)
};

const fr_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les pays`)
};

const de_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Länder`)
};

const ja_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての国`)
};

const zh_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有国家`)
};

const ar_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع الدول`)
};

const id_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Negara`)
};

const it_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i Paesi`)
};

const ru_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все страны`)
};

const pt_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os Países`)
};

const ko_all_countries = /** @type {(inputs: All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 국가`)
};

/**
* | output |
* | --- |
* | "All Countries" |
*
* @param {All_CountriesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const all_countries = /** @type {((inputs?: All_CountriesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_CountriesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_all_countries(inputs)
	if (locale === "es") return es_all_countries(inputs)
	if (locale === "fr") return fr_all_countries(inputs)
	if (locale === "de") return de_all_countries(inputs)
	if (locale === "ja") return ja_all_countries(inputs)
	if (locale === "zh") return zh_all_countries(inputs)
	if (locale === "ar") return ar_all_countries(inputs)
	if (locale === "id") return id_all_countries(inputs)
	if (locale === "it") return it_all_countries(inputs)
	if (locale === "ru") return ru_all_countries(inputs)
	if (locale === "pt") return pt_all_countries(inputs)
	return ko_all_countries(inputs)
});